import { Alert } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useQueryClient } from 'react-query';
import { transaction, payment } from 'apis';
import { useTranslation } from 'react-i18next';
import { useDialog } from 'context/dialogContext';
import { PaymentMethod } from 'enums';
import { useCardPaymentRqsts } from './useCardPaymentRqsts';

export const useSubmitPayment = () => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();
    const { openDialog } = useDialog();
    const { handleAlphaBankRqst, handlePiraeusBankRqst,handleStripeRqst } = useCardPaymentRqsts();

    const submitPayment = async (data) => {
        try {
            console.log('submitPayment data', data);
            const { token, transactionId, paymentMethod } = data;
            // const { transactionId, email, fullName, paidAt, paidAmount, captcha, token, comments, paymentMethod } = data;
            // eslint-disable-next-line no-alert
            // TODO Add Custom Confim Dialog Here
            openDialog({
                title:
                    paymentMethod === PaymentMethod.card.id.toString()
                        ? t('PaymentSubmittionDialogTitle_Card')
                        : t('PaymentSubmittionDialogTitle'),
                render: () => (
                    <Alert severity="warning" sx={{ cursor: 'pointer', mb: 2 }}>
                        {paymentMethod === PaymentMethod.card.id.toString()
                            ? t('PaymentSubmittionDialogWarning_Card')
                            : t('PaymentSubmittionDialogTitle')}
                    </Alert>
                ),
                acceptButtonTitle: t('Confirm'),
                cancelButtonTitle: t('Cancel'),
                onAccept: async () => {
                    await transaction
                        .submitPayment(
                            { ...data },
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`
                                }
                            }
                        )
                        .then(async (res) => {
                            console.log('res', res);
                            if (paymentMethod === PaymentMethod.card.id.toString()) {
                                if (res.operator === 'AlphaBank') await handleAlphaBankRqst(res);
                                else if (res.operator === 'Piraeus') await handlePiraeusBankRqst(res);
                                else if (res.operator === 'Stripe') await handleStripeRqst(res);
                            } else queryClient.invalidateQueries(['transactionDetails', transactionId]);
                        });
                    if (paymentMethod !== PaymentMethod.card.id.toString()) {
                        enqueueSnackbar(t('PaymentSubmittionSuccess'), {
                            variant: 'success'
                        });
                    }
                    queryClient.invalidateQueries(['transactionDetails', transactionId]);
                }
            });
        } catch (error) {
            throw new Error(
                'There was an error submitting the payment. Please try again later. If the problem persists, please contact the system administrator.'
            );
        }
    };

    return { submitPayment };
};
